import { useSelector } from 'react-redux'

import { LockedState } from '../types'
import { RootState } from '../../../reducers'
import { useEffect } from 'react'
import { isLockedSelector } from '../../app'

export function useLockedState(allowLog = false) {
  // @ts-ignore
  var stateDump = null

  const result = useSelector<RootState, LockedState>(state => {
    stateDump = state
    return lockedStateSelector(state)
  })

  useEffect(() => {
    // @ts-ignore
    stateDump && isLockedSelector(stateDump, allowLog)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result])

  return result
}

export function useIsLockedState(): boolean {
  return useLockedState().isLocked
}

export function lockedStateSelector(state: RootState, log = false): LockedState {
  if (isLockedSelector(state, log)) {
    return {
      isLocked: true,
      editingUsers: state.socketServer.roomState?.botState?.editingUsers
    }
  }

  return {
    isLocked: false
  }
}
